import { render, staticRenderFns } from "./SystemWhereUsedTab.vue?vue&type=template&id=3965cc71&"
import script from "./SystemWhereUsedTab.vue?vue&type=script&lang=js&"
export * from "./SystemWhereUsedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports